<template>
  <div v-if="isDeleteMode" class="editor-box">
    <ul ref="editor-box-check" class="editor-select">
      <li>
        <button
          type="button"
          :class="
            checkedCount > 0
              ? 'txt-editor-common txt-active'
              : 'txt-editor-common txt-detactive'
          "
          :disabled="checkedCount === 0"
          @click.prevent="deleteSelectedFn"
        >
          선택삭제(<span>{{ checkedCount | amount }}</span
          >)
        </button>
      </li>
      <li>
        <button
          type="button"
          class="txt-editor-common txt-active"
          @click.prevent="deleteAllFn"
        >
          전체삭제
          <template v-if="isEnableTotalCount"
            >(<span>{{ totalCount | amount }}</span
            >)</template
          >
        </button>
      </li>
    </ul>
    <ul class="editor-complete">
      <li>
        <button
          type="button"
          class="txt-editor-common txt-complete"
          @click.prevent="changeMode"
        >
          나가기
        </button>
      </li>
    </ul>
  </div>
  <div v-else class="editor-box-wrap">
    <div ref="editor-box" class="editor-box">
      <ul class="editor-edit">
        <li>
          <button
            type="button"
            class="txt-editor-common txt-editor"
            @click.prevent="changeMode"
          >
            편집
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { amount } from '@/common/filters'
  import utils from '@/common/util/utils'
  export default {
    name: 'MyPooqHistoryHeader',
    filters: {
      amount,
    },
    props: {
      changeMode: { type: Function },
      checkedCount: { type: Number },
      deleteAll: { type: Function },
      deleteSelected: { type: Function },
      isDeleteMode: { type: Boolean },
      totalCount: { type: Number },
      viewType: { type: String, default: '' },
    },
    computed: {
      isEnableTotalCount() {
        return this.viewType !== 'vod' && this.viewType !== 'movie'
      },
    },
    methods: {
      async deleteAllFn() {
        const confirmMsg =
          this.viewType === 'vod' || this.viewType === 'movie'
            ? '전체삭제를 진행하시겠습니까? 내역이 모두 삭제됩니다.'
            : `전체삭제를 진행하시겠습니까? ${this.totalCount}건의 내역이 모두 삭제됩니다.`
        if (this.viewType === 'singular' || this.viewType === 'package') {
          this.deleteAll()
        } else {
          if (await utils.asyncConfirm(confirmMsg)) {
            this.deleteAll()
          }
        }
      },
      deleteSelectedFn() {
        this.deleteSelected()
      },
    },
  }
</script>
